const LoginEvent = {
  updateReferrer: 'login/update-referrer',
  onChange: 'login/value-changed',
  failed: 'login/failed',
  initialized: 'login/initialized',
  logoutSuccess: 'login/logout-success'
}

export default LoginEvent
